module.exports = "<div class=\"container section-container\">\n  <div class=\"content\">\n    <div class=\"block\">\n      <div class=\"map\">\n        <map [isRouteMode]=\"true\"></map>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/routes.component.html
// module id = ../../../../../src/app/pages/routes.component.html
// module chunks = main